export function b64toFile(b64Data, filename, contentType) {
  var sliceSize = 512;
  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);

      for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
  }

  // Commented because IE11- doesn't support File
  // var file = new File(byteArrays, filename, {type: contentType})
  var file = new Blob(byteArrays, {type: contentType})
  return file
}
